angular
    .module('WizApp')
    .service('PublicAccountService', [
        '$http',
        '$filter',
        function ($http) {
            return {
                resetPassword(email) {
                    let accountDomain = window.sfParams.accountDomain ? window.sfParams.accountDomain : null;

                    const url = accountDomain + '/api/lost-password';

                    return $http.post(url, {
                        email,
                        app: 'website'
                    }, {
                        transformRequest: data => {
                            return JSON.stringify(data);
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                }
            };
        }
    ])
;
